import React, { lazy } from "react";
import HomeLayout from "../src/layouts/HomeLayout";
import LoginLayout from "../src/layouts/LoginLayout";
import DashboardLayout from "./layouts/DashboardLayout";

export const routes = [
  {
    exact: true,
    path: "/auth/login",
    layout: LoginLayout,
    component: lazy(() => import("../src/views/pages/Auth/Login/Login")),
  },
  {
    exact: true,
    path: "/auth/update-password",
    layout: LoginLayout,
    component: lazy(() =>
      import("../src/views/pages/Auth/UpdatePassword/UpdatePassword")
    ),
  },
  {
    exact: true,
    path: "/auth/verify-otp",
    layout: LoginLayout,
    component: lazy(() =>
      import("../src/views/pages/Auth/VerifyOpt/VerifyOtp")
    ),
  },
  {
    exact: true,
    path: "/auth/forgot-password",
    layout: LoginLayout,
    component: lazy(() =>
      import("../src/views/pages/Auth/ForgotPassword/ForgotPassword")
    ),
  },
  {
    exact: true,
    path: "/auth/reset-password",
    layout: LoginLayout,
    component: lazy(() =>
      import("../src/views/pages/Auth/ResetPassword/ResetPassword")
    ),
  },
  {
    exact: true,
    path: "/home",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("../src/views/pages/Dashboard/Dashboard")),
  },
  {
    exact: true,
    path: "/projects",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("../src/views/pages/Projects/Project")),
  },
  {
    exact: true,
    path: "/project/:id",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("../src/views/pages/Projects/ViewProject")),
  },
  {
    exact: true,
    path: "/tasks",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("../src/views/pages/Task/Task")),
  },
  {
    exact: true,
    path: "/task/:id",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("../src/views/pages/Task/ViewTask")),
  },
  // {
  //   exact: true,
  //   path: "/learning-center",
  //   guard: true,
  //   layout: DashboardLayout,
  //   component: lazy(() =>
  //     import("../src/views/pages/LearningCenter/LearningCenter")
  //   ),
  // },
  {
    exact: true,
    path: "/achievements",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("../src/views/pages/Achievements/Achievements")
    ),
  },
  {
    exact: true,
    path: "/my-certifications/video-course-certificate",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/Certificate/VideoCertificate")),
  },
  {
    exact: true,
    path: "/my-certifications/certificate",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/Certificate/Certificate")),
  },
  {
    exact: true,
    path: "/my-certifications",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/Certificate/CertificateType")),
  },
  {
    exact: true,
    path: "/compiler",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/Compiler/Compiler")),
  },
  {
    exact: true,
    path: "/offer-letter",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/OfferLetter/OfferLetter")),
  },
  {
    exact: true,
    path: "/ask-me",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/AskMe/AskMe")),
  },
  {
    exact: true,
    path: "/opportunity",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/Jobs/Jobs")),
  },
  {
    exact: true,
    path: "/theory-courses",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/LearningCenter/TheoryCourse")),
  },
  {
    exact: true,
    path: "/video-courses",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("./views/pages/LearningCenter/VideoCourse/VideoCourse")
    ),
  },
  {
    exact: true,
    path: "/theory-courses/course/:id",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/LearningCenter/Course")),
  },
  {
    exact: true,
    path: "/aptitude",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("./views/pages/LearningCenter/Aptitude/AptitudeList")
    ),
  },
  {
    exact: true,
    path: "/aptitude/view-aptitude/:id",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("./views/pages/LearningCenter/Aptitude/ViewAptitude")
    ),
  },
  {
    exact: true,
    path: "/interview",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("./views/pages/LearningCenter/Interview/ShowInterviewQuestions")
    ),
  },
  {
    exact: true,
    path: "/interview/view-interview/:id",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("./views/pages/LearningCenter/Interview/Interview")
    ),
  },
  {
    exact: true,
    path: "/notice-board",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/NoticeBoard/NoticeBoard")),
  },
  {
    exact: true,
    path: "/letter-of-internship",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() =>
      import("./views/pages/LetterInternship/LetterInternship")
    ),
  },
  {
    exact: true,
    path: "/notice-board/notice/:id",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/NoticeBoard/Notice")),
  },
  {
    exact: true,
    path: "/referral",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/Referral/Referral")),
  },
  {
    exact: true,
    path: "/referral/terms-condition",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/Referral/TermsCondition")),
  },
  {
    exact: true,
    path: "/referral/withdraw-history",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/Referral/Withdraws")),
  },
  {
    exact: true,
    path: "/my-profile",
    guard: true,
    layout: DashboardLayout,
    component: lazy(() => import("./views/pages/Profile/Profile")),
  },
  {
    exact: true,
    path: "/404",
    component: lazy(() => import("../src/views/errors/NotFound")),
  },
];
